// @generated by bzl gen
// @generated by protoc-gen-es v0.2.1 with parameter "target=ts"
// @generated from file dropbox/proto/context_engine/context_engine_conversations_service.proto (package context_engine, syntax proto3)
/* eslint-disable */
/* @ts-nocheck */

import type {
  BinaryReadOptions,
  FieldList,
  JsonReadOptions,
  JsonValue,
  PartialMessage,
  PlainMessage,
} from "@bufbuild/protobuf";
import {
  Empty,
  Message,
  proto3,
  protoInt64,
  Timestamp,
} from "@bufbuild/protobuf";
import { AnswersWorkflowError, Diagnostics } from "./answers_pb";
import {
  ConversationsChatMessage,
  ConversationsUserMessage,
  EvalRequestParams,
  ModelInfo,
  ProgressUpdate,
  SuggestedQuery,
  WriteDraft,
} from "./conversations_pb";
import { DevRequestOverrides } from "./dev_settings_pb";
import { ClientContext, DocumentInfo } from "./models_pb";

/**
 * @generated from enum context_engine.ToolsOrchestrationOverride
 */
export enum ToolsOrchestrationOverride {
  /**
   * Use default based on growthbook settings
   *
   * @generated from enum value: DEFAULT = 0;
   */
  DEFAULT = 0,

  /**
   * Force enable orchestration
   *
   * @generated from enum value: ENABLE = 1;
   */
  ENABLE = 1,

  /**
   * Force disable orchestration
   *
   * @generated from enum value: DISABLE = 2;
   */
  DISABLE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ToolsOrchestrationOverride)
proto3.util.setEnumType(
  ToolsOrchestrationOverride,
  "context_engine.ToolsOrchestrationOverride",
  [
    { no: 0, name: "DEFAULT" },
    { no: 1, name: "ENABLE" },
    { no: 2, name: "DISABLE" },
  ],
);

/**
 * @generated from enum context_engine.CapabilityTag
 */
export enum CapabilityTag {
  /**
   * @generated from enum value: UNKNOWN_TAG = 0;
   */
  UNKNOWN_TAG = 0,

  /**
   * @generated from enum value: MULTIMODAL = 1;
   */
  MULTIMODAL = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(CapabilityTag)
proto3.util.setEnumType(CapabilityTag, "context_engine.CapabilityTag", [
  { no: 0, name: "UNKNOWN_TAG" },
  { no: 1, name: "MULTIMODAL" },
]);

/**
 * @generated from message context_engine.ConversationsUserRequest
 */
export class ConversationsUserRequest extends Message<ConversationsUserRequest> {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId = "";

  /**
   * @generated from field: repeated context_engine.ConversationsChatMessage history = 2;
   */
  history: ConversationsChatMessage[] = [];

  /**
   * @generated from field: context_engine.ConversationsUserMessage user_message = 3;
   */
  userMessage?: ConversationsUserMessage;

  /**
   * @generated from field: bool debug_enabled = 5;
   */
  debugEnabled = false;

  /**
   * @generated from field: context_engine.ClientContext client_context = 6;
   */
  clientContext?: ClientContext;

  /**
   * @generated from field: string experiment_setting = 8;
   */
  experimentSetting = "";

  /**
   * @generated from field: string source = 9;
   */
  source = "";

  /**
   * @generated from field: context_engine.DevRequestOverrides dev_overrides = 10;
   */
  devOverrides?: DevRequestOverrides;

  /**
   * Deprecated. Use search_params instead.
   *
   * @generated from field: bool skip_search = 11;
   */
  skipSearch = false;

  /**
   * Optional model choice to use for the conversation.
   * This is an opaque id that is used to identify the model choice, not necessarily the model name.
   * If not provided, the service will choose the best model based on the user's context.
   *
   * @generated from field: string model_choice = 12;
   */
  modelChoice = "";

  /**
   * Optionally split documents into individual pages whenever possible. (Currently only supported for FSS)
   *
   * @generated from field: bool enable_pagination = 15;
   */
  enablePagination = false;

  /**
   * @generated from field: context_engine.SearchParams search_params = 16;
   */
  searchParams?: SearchParams;

  /**
   * Skip persisting the conversation to the database.
   *
   * @generated from field: bool skip_persistence = 17;
   */
  skipPersistence = false;

  /**
   * @generated from field: bool eval_mode = 18;
   */
  evalMode = false;

  /**
   * @generated from field: context_engine.EvalRequestParams eval_params = 19;
   */
  evalParams?: EvalRequestParams;

  /**
   * Retrieval system to use: dcs or fss - default dcs
   *
   * @generated from field: string retriever = 20;
   */
  retriever = "";

  /**
   * @generated from field: context_engine.ToolsOrchestrationOverride tools_orchestration = 21;
   */
  toolsOrchestration = ToolsOrchestrationOverride.DEFAULT;

  /**
   * Stack ID (namespace ID). When provided, the conversation will be scoped to the given stack
   * EX: "ns:12557191953"
   *
   * @generated from field: string stack_id = 22;
   */
  stackId = "";

  constructor(data?: PartialMessage<ConversationsUserRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConversationsUserRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "conversation_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 2,
      name: "history",
      kind: "message",
      T: ConversationsChatMessage,
      repeated: true,
    },
    {
      no: 3,
      name: "user_message",
      kind: "message",
      T: ConversationsUserMessage,
    },
    {
      no: 5,
      name: "debug_enabled",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    { no: 6, name: "client_context", kind: "message", T: ClientContext },
    {
      no: 8,
      name: "experiment_setting",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 9, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "dev_overrides", kind: "message", T: DevRequestOverrides },
    { no: 11, name: "skip_search", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    {
      no: 12,
      name: "model_choice",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 15,
      name: "enable_pagination",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    { no: 16, name: "search_params", kind: "message", T: SearchParams },
    {
      no: 17,
      name: "skip_persistence",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    { no: 18, name: "eval_mode", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "eval_params", kind: "message", T: EvalRequestParams },
    { no: 20, name: "retriever", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 21,
      name: "tools_orchestration",
      kind: "enum",
      T: proto3.getEnumType(ToolsOrchestrationOverride),
    },
    { no: 22, name: "stack_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConversationsUserRequest {
    return new ConversationsUserRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConversationsUserRequest {
    return new ConversationsUserRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConversationsUserRequest {
    return new ConversationsUserRequest().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | ConversationsUserRequest
      | PlainMessage<ConversationsUserRequest>
      | undefined,
    b:
      | ConversationsUserRequest
      | PlainMessage<ConversationsUserRequest>
      | undefined,
  ): boolean {
    return proto3.util.equals(ConversationsUserRequest, a, b);
  }
}

/**
 * @generated from message context_engine.SearchParams
 */
export class SearchParams extends Message<SearchParams> {
  /**
   * @generated from oneof context_engine.SearchParams.search_target
   */
  searchTarget:
    | {
        /**
         * @generated from field: context_engine.NoSearch no_search = 1;
         */
        value: NoSearch;
        case: "noSearch";
      }
    | {
        /**
         * @generated from field: context_engine.DashSearch dash_search = 2;
         */
        value: DashSearch;
        case: "dashSearch";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SearchParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.SearchParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "no_search",
      kind: "message",
      T: NoSearch,
      oneof: "search_target",
    },
    {
      no: 2,
      name: "dash_search",
      kind: "message",
      T: DashSearch,
      oneof: "search_target",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): SearchParams {
    return new SearchParams().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): SearchParams {
    return new SearchParams().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): SearchParams {
    return new SearchParams().fromJsonString(jsonString, options);
  }

  static equals(
    a: SearchParams | PlainMessage<SearchParams> | undefined,
    b: SearchParams | PlainMessage<SearchParams> | undefined,
  ): boolean {
    return proto3.util.equals(SearchParams, a, b);
  }
}

/**
 * @generated from message context_engine.NoSearch
 */
export class NoSearch extends Message<NoSearch> {
  constructor(data?: PartialMessage<NoSearch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.NoSearch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => []);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): NoSearch {
    return new NoSearch().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): NoSearch {
    return new NoSearch().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): NoSearch {
    return new NoSearch().fromJsonString(jsonString, options);
  }

  static equals(
    a: NoSearch | PlainMessage<NoSearch> | undefined,
    b: NoSearch | PlainMessage<NoSearch> | undefined,
  ): boolean {
    return proto3.util.equals(NoSearch, a, b);
  }
}

/**
 * TODO: Add support for query filters
 *
 * @generated from message context_engine.DashSearch
 */
export class DashSearch extends Message<DashSearch> {
  constructor(data?: PartialMessage<DashSearch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.DashSearch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => []);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DashSearch {
    return new DashSearch().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DashSearch {
    return new DashSearch().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DashSearch {
    return new DashSearch().fromJsonString(jsonString, options);
  }

  static equals(
    a: DashSearch | PlainMessage<DashSearch> | undefined,
    b: DashSearch | PlainMessage<DashSearch> | undefined,
  ): boolean {
    return proto3.util.equals(DashSearch, a, b);
  }
}

/**
 * @generated from message context_engine.ConversationsAssistantResponse
 */
export class ConversationsAssistantResponse extends Message<ConversationsAssistantResponse> {
  /**
   * @generated from field: repeated context_engine.ConversationsChatMessage messages = 1;
   */
  messages: ConversationsChatMessage[] = [];

  /**
   * @generated from field: context_engine.Diagnostics diagnostics = 2;
   */
  diagnostics?: Diagnostics;

  /**
   * @generated from field: repeated context_engine.ProgressUpdate progress_updates = 3;
   */
  progressUpdates: ProgressUpdate[] = [];

  /**
   * @generated from field: string conversation_id = 4;
   */
  conversationId = "";

  /**
   * @generated from field: repeated context_engine.SuggestedQuery suggested_queries = 5;
   */
  suggestedQueries: SuggestedQuery[] = [];

  /**
   * @generated from field: string request_id = 6;
   */
  requestId = "";

  /**
   * @generated from field: context_engine.WriteDraft draft = 7;
   */
  draft?: WriteDraft;

  /**
   * @generated from field: string title = 8;
   */
  title = "";

  /**
   * @generated from field: string preview = 9;
   */
  preview = "";

  /**
   * @generated from field: string span_id = 10;
   */
  spanId = "";

  /**
   * @generated from field: repeated context_engine.CapabilityTag tags = 11;
   */
  tags: CapabilityTag[] = [];

  constructor(data?: PartialMessage<ConversationsAssistantResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConversationsAssistantResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "messages",
      kind: "message",
      T: ConversationsChatMessage,
      repeated: true,
    },
    { no: 2, name: "diagnostics", kind: "message", T: Diagnostics },
    {
      no: 3,
      name: "progress_updates",
      kind: "message",
      T: ProgressUpdate,
      repeated: true,
    },
    {
      no: 4,
      name: "conversation_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 5,
      name: "suggested_queries",
      kind: "message",
      T: SuggestedQuery,
      repeated: true,
    },
    { no: 6, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "draft", kind: "message", T: WriteDraft },
    { no: 8, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "preview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "span_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 11,
      name: "tags",
      kind: "enum",
      T: proto3.getEnumType(CapabilityTag),
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConversationsAssistantResponse {
    return new ConversationsAssistantResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConversationsAssistantResponse {
    return new ConversationsAssistantResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConversationsAssistantResponse {
    return new ConversationsAssistantResponse().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | ConversationsAssistantResponse
      | PlainMessage<ConversationsAssistantResponse>
      | undefined,
    b:
      | ConversationsAssistantResponse
      | PlainMessage<ConversationsAssistantResponse>
      | undefined,
  ): boolean {
    return proto3.util.equals(ConversationsAssistantResponse, a, b);
  }
}

/**
 * @generated from message context_engine.ConversationsGetResponseError
 */
export class ConversationsGetResponseError extends Message<ConversationsGetResponseError> {
  /**
   * @generated from oneof context_engine.ConversationsGetResponseError.err
   */
  err:
    | {
        /**
         * Indicates that a required argument was not provided.
         *
         * @generated from field: google.protobuf.Empty missing_required_args = 1;
         */
        value: Empty;
        case: "missingRequiredArgs";
      }
    | {
        /**
         * Indicates that an argument was provided that is not allowed.
         *
         * @generated from field: google.protobuf.Empty invalid_args = 2;
         */
        value: Empty;
        case: "invalidArgs";
      }
    | {
        /**
         * Indicates that the user is not authorized to access the requested resource.
         *
         * @generated from field: google.protobuf.Empty unauthorized = 3;
         */
        value: Empty;
        case: "unauthorized";
      }
    | {
        /**
         * Indicates that the request was not processed due to an internal error.
         *
         * @generated from field: google.protobuf.Empty internal_failure = 4;
         */
        value: Empty;
        case: "internalFailure";
      }
    | {
        /**
         * Indicates that there was an error loading files.
         *
         * @generated from field: google.protobuf.Empty failed_to_get_files = 5;
         */
        value: Empty;
        case: "failedToGetFiles";
      }
    | {
        /**
         * @generated from field: context_engine.AnswersWorkflowError workflow_err = 7;
         */
        value: AnswersWorkflowError;
        case: "workflowErr";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ConversationsGetResponseError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConversationsGetResponseError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "missing_required_args",
      kind: "message",
      T: Empty,
      oneof: "err",
    },
    { no: 2, name: "invalid_args", kind: "message", T: Empty, oneof: "err" },
    { no: 3, name: "unauthorized", kind: "message", T: Empty, oneof: "err" },
    {
      no: 4,
      name: "internal_failure",
      kind: "message",
      T: Empty,
      oneof: "err",
    },
    {
      no: 5,
      name: "failed_to_get_files",
      kind: "message",
      T: Empty,
      oneof: "err",
    },
    {
      no: 7,
      name: "workflow_err",
      kind: "message",
      T: AnswersWorkflowError,
      oneof: "err",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConversationsGetResponseError {
    return new ConversationsGetResponseError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConversationsGetResponseError {
    return new ConversationsGetResponseError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConversationsGetResponseError {
    return new ConversationsGetResponseError().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | ConversationsGetResponseError
      | PlainMessage<ConversationsGetResponseError>
      | undefined,
    b:
      | ConversationsGetResponseError
      | PlainMessage<ConversationsGetResponseError>
      | undefined,
  ): boolean {
    return proto3.util.equals(ConversationsGetResponseError, a, b);
  }
}

/**
 * @generated from message context_engine.QuerySuggestionsRequest
 */
export class QuerySuggestionsRequest extends Message<QuerySuggestionsRequest> {
  /**
   * DEPRECATED: Use document_infos instead and pass in the document ids as the uuids
   *
   * @generated from field: repeated string document_ids = 1 [deprecated = true];
   * @deprecated
   */
  documentIds: string[] = [];

  /**
   * Used for experimentation. V1, V2, V3 etc.
   *
   * @generated from field: string experiment_setting = 2;
   */
  experimentSetting = "";

  /**
   * Include context in the LLM reqeust for more personalized responses.
   *
   * @generated from field: context_engine.ClientContext client_context = 3;
   */
  clientContext?: ClientContext;

  /**
   * Include debug information, so that we understand the whole pipeline
   *
   * @generated from field: bool debug = 4;
   */
  debug = false;

  /**
   * Source of the request for tracking - dash, context_engine_test etc.
   *
   * @generated from field: string source = 5;
   */
  source = "";

  /**
   * Optional - use if we want to generate suggestions based on a user query.
   *
   * @generated from field: string user_query = 6;
   */
  userQuery = "";

  /**
   * The maximum number of suggestions to generate.
   *
   * @generated from field: int32 max_suggestions = 7;
   */
  maxSuggestions = 0;

  /**
   * Optional stack_id (stack public sharing id) to use for basing the suggestions on.
   *
   * @generated from field: string stack_id = 8;
   */
  stackId = "";

  /**
   * Optional Conversation Pipeline  model choice to use for the suggestions. Overrides "experiment_setting"
   *
   * @generated from field: string model_choice = 9;
   */
  modelChoice = "";

  /**
   * Used to scope fss query suggestions to a specific path in the fss. Default is empty
   *
   * @generated from field: string fss_search_scope = 10;
   */
  fssSearchScope = "";

  /**
   * Used to determine whether to use fss or dcs logic. default is dcs
   *
   * @generated from field: string retriever = 11;
   */
  retriever = "";

  /**
   * Optional - use if we want to generate suggestions based on specific documents.
   *
   * @generated from field: repeated context_engine.DocumentInfo document_infos = 12;
   */
  documentInfos: DocumentInfo[] = [];

  /**
   * @generated from field: context_engine.DevRequestOverrides dev_overrides = 100;
   */
  devOverrides?: DevRequestOverrides;

  constructor(data?: PartialMessage<QuerySuggestionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.QuerySuggestionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "document_ids",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 2,
      name: "experiment_setting",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 3, name: "client_context", kind: "message", T: ClientContext },
    { no: 4, name: "debug", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "user_query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 7,
      name: "max_suggestions",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    { no: 8, name: "stack_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 9,
      name: "model_choice",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 10,
      name: "fss_search_scope",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 11, name: "retriever", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 12,
      name: "document_infos",
      kind: "message",
      T: DocumentInfo,
      repeated: true,
    },
    { no: 100, name: "dev_overrides", kind: "message", T: DevRequestOverrides },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): QuerySuggestionsRequest {
    return new QuerySuggestionsRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): QuerySuggestionsRequest {
    return new QuerySuggestionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): QuerySuggestionsRequest {
    return new QuerySuggestionsRequest().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | QuerySuggestionsRequest
      | PlainMessage<QuerySuggestionsRequest>
      | undefined,
    b:
      | QuerySuggestionsRequest
      | PlainMessage<QuerySuggestionsRequest>
      | undefined,
  ): boolean {
    return proto3.util.equals(QuerySuggestionsRequest, a, b);
  }
}

/**
 * @generated from message context_engine.QuerySuggestionsError
 */
export class QuerySuggestionsError extends Message<QuerySuggestionsError> {
  /**
   * @generated from oneof context_engine.QuerySuggestionsError.err
   */
  err:
    | {
        /**
         * @generated from field: context_engine.AnswersWorkflowError workflow_err = 2;
         */
        value: AnswersWorkflowError;
        case: "workflowErr";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<QuerySuggestionsError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.QuerySuggestionsError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 2,
      name: "workflow_err",
      kind: "message",
      T: AnswersWorkflowError,
      oneof: "err",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): QuerySuggestionsError {
    return new QuerySuggestionsError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): QuerySuggestionsError {
    return new QuerySuggestionsError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): QuerySuggestionsError {
    return new QuerySuggestionsError().fromJsonString(jsonString, options);
  }

  static equals(
    a: QuerySuggestionsError | PlainMessage<QuerySuggestionsError> | undefined,
    b: QuerySuggestionsError | PlainMessage<QuerySuggestionsError> | undefined,
  ): boolean {
    return proto3.util.equals(QuerySuggestionsError, a, b);
  }
}

/**
 * @generated from message context_engine.QuerySuggestionsResponse
 */
export class QuerySuggestionsResponse extends Message<QuerySuggestionsResponse> {
  /**
   * @generated from field: repeated context_engine.SuggestedQuery query_suggestions = 1;
   */
  querySuggestions: SuggestedQuery[] = [];

  /**
   * @generated from field: string request_id = 2;
   */
  requestId = "";

  /**
   * @generated from field: context_engine.Diagnostics diagnostics = 100;
   */
  diagnostics?: Diagnostics;

  /**
   * @generated from field: context_engine.DevRequestOverrides dev_overrides = 101;
   */
  devOverrides?: DevRequestOverrides;

  constructor(data?: PartialMessage<QuerySuggestionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.QuerySuggestionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "query_suggestions",
      kind: "message",
      T: SuggestedQuery,
      repeated: true,
    },
    { no: 2, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "diagnostics", kind: "message", T: Diagnostics },
    { no: 101, name: "dev_overrides", kind: "message", T: DevRequestOverrides },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): QuerySuggestionsResponse {
    return new QuerySuggestionsResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): QuerySuggestionsResponse {
    return new QuerySuggestionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): QuerySuggestionsResponse {
    return new QuerySuggestionsResponse().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | QuerySuggestionsResponse
      | PlainMessage<QuerySuggestionsResponse>
      | undefined,
    b:
      | QuerySuggestionsResponse
      | PlainMessage<QuerySuggestionsResponse>
      | undefined,
  ): boolean {
    return proto3.util.equals(QuerySuggestionsResponse, a, b);
  }
}

/**
 * @generated from message context_engine.ListAvailableModelsRequest
 */
export class ListAvailableModelsRequest extends Message<ListAvailableModelsRequest> {
  constructor(data?: PartialMessage<ListAvailableModelsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ListAvailableModelsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => []);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ListAvailableModelsRequest {
    return new ListAvailableModelsRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ListAvailableModelsRequest {
    return new ListAvailableModelsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ListAvailableModelsRequest {
    return new ListAvailableModelsRequest().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | ListAvailableModelsRequest
      | PlainMessage<ListAvailableModelsRequest>
      | undefined,
    b:
      | ListAvailableModelsRequest
      | PlainMessage<ListAvailableModelsRequest>
      | undefined,
  ): boolean {
    return proto3.util.equals(ListAvailableModelsRequest, a, b);
  }
}

/**
 * @generated from message context_engine.ListAvailableModelsResponse
 */
export class ListAvailableModelsResponse extends Message<ListAvailableModelsResponse> {
  /**
   * List of models that are available for the user
   *
   * @generated from field: repeated context_engine.ModelInfo models = 1;
   */
  models: ModelInfo[] = [];

  constructor(data?: PartialMessage<ListAvailableModelsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ListAvailableModelsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "models", kind: "message", T: ModelInfo, repeated: true },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ListAvailableModelsResponse {
    return new ListAvailableModelsResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ListAvailableModelsResponse {
    return new ListAvailableModelsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ListAvailableModelsResponse {
    return new ListAvailableModelsResponse().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | ListAvailableModelsResponse
      | PlainMessage<ListAvailableModelsResponse>
      | undefined,
    b:
      | ListAvailableModelsResponse
      | PlainMessage<ListAvailableModelsResponse>
      | undefined,
  ): boolean {
    return proto3.util.equals(ListAvailableModelsResponse, a, b);
  }
}

/**
 * @generated from message context_engine.ListAvailableModelsError
 */
export class ListAvailableModelsError extends Message<ListAvailableModelsError> {
  /**
   * @generated from oneof context_engine.ListAvailableModelsError.err
   */
  err:
    | {
        /**
         * @generated from field: google.protobuf.Empty internal_failure = 1;
         */
        value: Empty;
        case: "internalFailure";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ListAvailableModelsError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ListAvailableModelsError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "internal_failure",
      kind: "message",
      T: Empty,
      oneof: "err",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ListAvailableModelsError {
    return new ListAvailableModelsError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ListAvailableModelsError {
    return new ListAvailableModelsError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ListAvailableModelsError {
    return new ListAvailableModelsError().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | ListAvailableModelsError
      | PlainMessage<ListAvailableModelsError>
      | undefined,
    b:
      | ListAvailableModelsError
      | PlainMessage<ListAvailableModelsError>
      | undefined,
  ): boolean {
    return proto3.util.equals(ListAvailableModelsError, a, b);
  }
}

/**
 * @generated from message context_engine.UserConversation
 */
export class UserConversation extends Message<UserConversation> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string title = 4;
   */
  title = "";

  /**
   * @generated from field: context_engine.WriteDraft draft = 5;
   */
  draft?: WriteDraft;

  /**
   * @generated from field: context_engine.ClientContext client_context = 6;
   */
  clientContext?: ClientContext;

  /**
   * @generated from field: google.protobuf.Timestamp created_ts = 7;
   */
  createdTs?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_ts = 8;
   */
  updatedTs?: Timestamp;

  /**
   * @generated from field: string initial_agent = 9;
   */
  initialAgent = "";

  /**
   * @generated from field: string preview = 10;
   */
  preview = "";

  /**
   * If present, the conversation is scoped to this stack
   *
   * @generated from field: string stack_id = 11;
   */
  stackId = "";

  constructor(data?: PartialMessage<UserConversation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UserConversation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "draft", kind: "message", T: WriteDraft },
    { no: 6, name: "client_context", kind: "message", T: ClientContext },
    { no: 7, name: "created_ts", kind: "message", T: Timestamp },
    { no: 8, name: "updated_ts", kind: "message", T: Timestamp },
    {
      no: 9,
      name: "initial_agent",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 10, name: "preview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "stack_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UserConversation {
    return new UserConversation().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UserConversation {
    return new UserConversation().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UserConversation {
    return new UserConversation().fromJsonString(jsonString, options);
  }

  static equals(
    a: UserConversation | PlainMessage<UserConversation> | undefined,
    b: UserConversation | PlainMessage<UserConversation> | undefined,
  ): boolean {
    return proto3.util.equals(UserConversation, a, b);
  }
}

/**
 * @generated from message context_engine.ListUserConversationsRequest
 */
export class ListUserConversationsRequest extends Message<ListUserConversationsRequest> {
  /**
   * The cursor to use for pagination
   *
   * @generated from field: string cursor = 1;
   */
  cursor = "";

  constructor(data?: PartialMessage<ListUserConversationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ListUserConversationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ListUserConversationsRequest {
    return new ListUserConversationsRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ListUserConversationsRequest {
    return new ListUserConversationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ListUserConversationsRequest {
    return new ListUserConversationsRequest().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | ListUserConversationsRequest
      | PlainMessage<ListUserConversationsRequest>
      | undefined,
    b:
      | ListUserConversationsRequest
      | PlainMessage<ListUserConversationsRequest>
      | undefined,
  ): boolean {
    return proto3.util.equals(ListUserConversationsRequest, a, b);
  }
}

/**
 * @generated from message context_engine.ListUserConversationsResponse
 */
export class ListUserConversationsResponse extends Message<ListUserConversationsResponse> {
  /**
   * The list of conversations
   *
   * @generated from field: repeated context_engine.UserConversation conversations = 1;
   */
  conversations: UserConversation[] = [];

  /**
   * The cursor to use for pagination
   *
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<ListUserConversationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ListUserConversationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "conversations",
      kind: "message",
      T: UserConversation,
      repeated: true,
    },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ListUserConversationsResponse {
    return new ListUserConversationsResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ListUserConversationsResponse {
    return new ListUserConversationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ListUserConversationsResponse {
    return new ListUserConversationsResponse().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | ListUserConversationsResponse
      | PlainMessage<ListUserConversationsResponse>
      | undefined,
    b:
      | ListUserConversationsResponse
      | PlainMessage<ListUserConversationsResponse>
      | undefined,
  ): boolean {
    return proto3.util.equals(ListUserConversationsResponse, a, b);
  }
}

/**
 * @generated from message context_engine.ListUserConversationsError
 */
export class ListUserConversationsError extends Message<ListUserConversationsError> {
  /**
   * @generated from oneof context_engine.ListUserConversationsError.err
   */
  err:
    | {
        /**
         * @generated from field: google.protobuf.Empty invalid_args = 1;
         */
        value: Empty;
        case: "invalidArgs";
      }
    | {
        /**
         * @generated from field: google.protobuf.Empty internal_failure = 2;
         */
        value: Empty;
        case: "internalFailure";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ListUserConversationsError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ListUserConversationsError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invalid_args", kind: "message", T: Empty, oneof: "err" },
    {
      no: 2,
      name: "internal_failure",
      kind: "message",
      T: Empty,
      oneof: "err",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ListUserConversationsError {
    return new ListUserConversationsError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ListUserConversationsError {
    return new ListUserConversationsError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ListUserConversationsError {
    return new ListUserConversationsError().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | ListUserConversationsError
      | PlainMessage<ListUserConversationsError>
      | undefined,
    b:
      | ListUserConversationsError
      | PlainMessage<ListUserConversationsError>
      | undefined,
  ): boolean {
    return proto3.util.equals(ListUserConversationsError, a, b);
  }
}

/**
 * @generated from message context_engine.GetUserConversationRequest
 */
export class GetUserConversationRequest extends Message<GetUserConversationRequest> {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId = "";

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetUserConversationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.GetUserConversationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "conversation_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): GetUserConversationRequest {
    return new GetUserConversationRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): GetUserConversationRequest {
    return new GetUserConversationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): GetUserConversationRequest {
    return new GetUserConversationRequest().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | GetUserConversationRequest
      | PlainMessage<GetUserConversationRequest>
      | undefined,
    b:
      | GetUserConversationRequest
      | PlainMessage<GetUserConversationRequest>
      | undefined,
  ): boolean {
    return proto3.util.equals(GetUserConversationRequest, a, b);
  }
}

/**
 * @generated from message context_engine.GetUserConversationResponse
 */
export class GetUserConversationResponse extends Message<GetUserConversationResponse> {
  /**
   * @generated from field: context_engine.UserConversation conversation = 1;
   */
  conversation?: UserConversation;

  /**
   * @generated from field: repeated context_engine.ConversationsChatMessage messages = 2;
   */
  messages: ConversationsChatMessage[] = [];

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetUserConversationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.GetUserConversationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversation", kind: "message", T: UserConversation },
    {
      no: 2,
      name: "messages",
      kind: "message",
      T: ConversationsChatMessage,
      repeated: true,
    },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): GetUserConversationResponse {
    return new GetUserConversationResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): GetUserConversationResponse {
    return new GetUserConversationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): GetUserConversationResponse {
    return new GetUserConversationResponse().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | GetUserConversationResponse
      | PlainMessage<GetUserConversationResponse>
      | undefined,
    b:
      | GetUserConversationResponse
      | PlainMessage<GetUserConversationResponse>
      | undefined,
  ): boolean {
    return proto3.util.equals(GetUserConversationResponse, a, b);
  }
}

/**
 * @generated from message context_engine.GetUserConversationError
 */
export class GetUserConversationError extends Message<GetUserConversationError> {
  /**
   * @generated from oneof context_engine.GetUserConversationError.err
   */
  err:
    | {
        /**
         * @generated from field: google.protobuf.Empty not_found = 1;
         */
        value: Empty;
        case: "notFound";
      }
    | {
        /**
         * @generated from field: google.protobuf.Empty internal_failure = 2;
         */
        value: Empty;
        case: "internalFailure";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<GetUserConversationError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.GetUserConversationError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "not_found", kind: "message", T: Empty, oneof: "err" },
    {
      no: 2,
      name: "internal_failure",
      kind: "message",
      T: Empty,
      oneof: "err",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): GetUserConversationError {
    return new GetUserConversationError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): GetUserConversationError {
    return new GetUserConversationError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): GetUserConversationError {
    return new GetUserConversationError().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | GetUserConversationError
      | PlainMessage<GetUserConversationError>
      | undefined,
    b:
      | GetUserConversationError
      | PlainMessage<GetUserConversationError>
      | undefined,
  ): boolean {
    return proto3.util.equals(GetUserConversationError, a, b);
  }
}

/**
 * @generated from message context_engine.DeleteUserConversationsRequest
 */
export class DeleteUserConversationsRequest extends Message<DeleteUserConversationsRequest> {
  /**
   * @generated from field: repeated string conversation_ids = 1;
   */
  conversationIds: string[] = [];

  constructor(data?: PartialMessage<DeleteUserConversationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.DeleteUserConversationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "conversation_ids",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DeleteUserConversationsRequest {
    return new DeleteUserConversationsRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DeleteUserConversationsRequest {
    return new DeleteUserConversationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DeleteUserConversationsRequest {
    return new DeleteUserConversationsRequest().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | DeleteUserConversationsRequest
      | PlainMessage<DeleteUserConversationsRequest>
      | undefined,
    b:
      | DeleteUserConversationsRequest
      | PlainMessage<DeleteUserConversationsRequest>
      | undefined,
  ): boolean {
    return proto3.util.equals(DeleteUserConversationsRequest, a, b);
  }
}

/**
 * @generated from message context_engine.DeleteUserConversationsResponse
 */
export class DeleteUserConversationsResponse extends Message<DeleteUserConversationsResponse> {
  /**
   * @generated from field: repeated string deleted_ids = 1;
   */
  deletedIds: string[] = [];

  constructor(data?: PartialMessage<DeleteUserConversationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.DeleteUserConversationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "deleted_ids",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DeleteUserConversationsResponse {
    return new DeleteUserConversationsResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DeleteUserConversationsResponse {
    return new DeleteUserConversationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DeleteUserConversationsResponse {
    return new DeleteUserConversationsResponse().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | DeleteUserConversationsResponse
      | PlainMessage<DeleteUserConversationsResponse>
      | undefined,
    b:
      | DeleteUserConversationsResponse
      | PlainMessage<DeleteUserConversationsResponse>
      | undefined,
  ): boolean {
    return proto3.util.equals(DeleteUserConversationsResponse, a, b);
  }
}

/**
 * @generated from message context_engine.DeleteUserConversationsError
 */
export class DeleteUserConversationsError extends Message<DeleteUserConversationsError> {
  /**
   * @generated from oneof context_engine.DeleteUserConversationsError.err
   */
  err:
    | {
        /**
         * @generated from field: google.protobuf.Empty invalid_args = 1;
         */
        value: Empty;
        case: "invalidArgs";
      }
    | {
        /**
         * @generated from field: google.protobuf.Empty unauthorized = 2;
         */
        value: Empty;
        case: "unauthorized";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<DeleteUserConversationsError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.DeleteUserConversationsError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invalid_args", kind: "message", T: Empty, oneof: "err" },
    { no: 2, name: "unauthorized", kind: "message", T: Empty, oneof: "err" },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DeleteUserConversationsError {
    return new DeleteUserConversationsError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DeleteUserConversationsError {
    return new DeleteUserConversationsError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DeleteUserConversationsError {
    return new DeleteUserConversationsError().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | DeleteUserConversationsError
      | PlainMessage<DeleteUserConversationsError>
      | undefined,
    b:
      | DeleteUserConversationsError
      | PlainMessage<DeleteUserConversationsError>
      | undefined,
  ): boolean {
    return proto3.util.equals(DeleteUserConversationsError, a, b);
  }
}

/**
 * @generated from message context_engine.DeleteAllUserConversationsRequest
 */
export class DeleteAllUserConversationsRequest extends Message<DeleteAllUserConversationsRequest> {
  /**
   * @generated from field: uint64 user_id = 1;
   */
  userId = protoInt64.zero;

  /**
   * @generated from field: bool wet_run = 2;
   */
  wetRun = false;

  constructor(data?: PartialMessage<DeleteAllUserConversationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.DeleteAllUserConversationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "wet_run", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DeleteAllUserConversationsRequest {
    return new DeleteAllUserConversationsRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DeleteAllUserConversationsRequest {
    return new DeleteAllUserConversationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DeleteAllUserConversationsRequest {
    return new DeleteAllUserConversationsRequest().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | DeleteAllUserConversationsRequest
      | PlainMessage<DeleteAllUserConversationsRequest>
      | undefined,
    b:
      | DeleteAllUserConversationsRequest
      | PlainMessage<DeleteAllUserConversationsRequest>
      | undefined,
  ): boolean {
    return proto3.util.equals(DeleteAllUserConversationsRequest, a, b);
  }
}

/**
 * @generated from message context_engine.DeleteAllUserConversationsResponse
 */
export class DeleteAllUserConversationsResponse extends Message<DeleteAllUserConversationsResponse> {
  /**
   * @generated from field: bool dry_run = 1;
   */
  dryRun = false;

  /**
   * @generated from field: int32 item_count = 2;
   */
  itemCount = 0;

  /**
   * @generated from field: int32 deleted_count = 3;
   */
  deletedCount = 0;

  constructor(data?: PartialMessage<DeleteAllUserConversationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName =
    "context_engine.DeleteAllUserConversationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dry_run", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "item_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    {
      no: 3,
      name: "deleted_count",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DeleteAllUserConversationsResponse {
    return new DeleteAllUserConversationsResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DeleteAllUserConversationsResponse {
    return new DeleteAllUserConversationsResponse().fromJson(
      jsonValue,
      options,
    );
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DeleteAllUserConversationsResponse {
    return new DeleteAllUserConversationsResponse().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | DeleteAllUserConversationsResponse
      | PlainMessage<DeleteAllUserConversationsResponse>
      | undefined,
    b:
      | DeleteAllUserConversationsResponse
      | PlainMessage<DeleteAllUserConversationsResponse>
      | undefined,
  ): boolean {
    return proto3.util.equals(DeleteAllUserConversationsResponse, a, b);
  }
}

/**
 * @generated from message context_engine.DeleteAllUserConversationsError
 */
export class DeleteAllUserConversationsError extends Message<DeleteAllUserConversationsError> {
  /**
   * @generated from oneof context_engine.DeleteAllUserConversationsError.err
   */
  err:
    | {
        /**
         * @generated from field: google.protobuf.Empty invalid_args = 1;
         */
        value: Empty;
        case: "invalidArgs";
      }
    | {
        /**
         * @generated from field: google.protobuf.Empty unauthorized = 2;
         */
        value: Empty;
        case: "unauthorized";
      }
    | {
        /**
         * @generated from field: google.protobuf.Empty internal_failure = 3;
         */
        value: Empty;
        case: "internalFailure";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<DeleteAllUserConversationsError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.DeleteAllUserConversationsError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invalid_args", kind: "message", T: Empty, oneof: "err" },
    { no: 2, name: "unauthorized", kind: "message", T: Empty, oneof: "err" },
    {
      no: 3,
      name: "internal_failure",
      kind: "message",
      T: Empty,
      oneof: "err",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DeleteAllUserConversationsError {
    return new DeleteAllUserConversationsError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DeleteAllUserConversationsError {
    return new DeleteAllUserConversationsError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DeleteAllUserConversationsError {
    return new DeleteAllUserConversationsError().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | DeleteAllUserConversationsError
      | PlainMessage<DeleteAllUserConversationsError>
      | undefined,
    b:
      | DeleteAllUserConversationsError
      | PlainMessage<DeleteAllUserConversationsError>
      | undefined,
  ): boolean {
    return proto3.util.equals(DeleteAllUserConversationsError, a, b);
  }
}

/**
 * @generated from message context_engine.UpdateUserConversationRequest
 */
export class UpdateUserConversationRequest extends Message<UpdateUserConversationRequest> {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId = "";

  /**
   * Add other updatable fields here
   *
   * @generated from field: string title = 2;
   */
  title = "";

  constructor(data?: PartialMessage<UpdateUserConversationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UpdateUserConversationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "conversation_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UpdateUserConversationRequest {
    return new UpdateUserConversationRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UpdateUserConversationRequest {
    return new UpdateUserConversationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UpdateUserConversationRequest {
    return new UpdateUserConversationRequest().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | UpdateUserConversationRequest
      | PlainMessage<UpdateUserConversationRequest>
      | undefined,
    b:
      | UpdateUserConversationRequest
      | PlainMessage<UpdateUserConversationRequest>
      | undefined,
  ): boolean {
    return proto3.util.equals(UpdateUserConversationRequest, a, b);
  }
}

/**
 * @generated from message context_engine.UpdateUserConversationResponse
 */
export class UpdateUserConversationResponse extends Message<UpdateUserConversationResponse> {
  /**
   * @generated from field: context_engine.UserConversation conversation = 1;
   */
  conversation?: UserConversation;

  constructor(data?: PartialMessage<UpdateUserConversationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UpdateUserConversationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversation", kind: "message", T: UserConversation },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UpdateUserConversationResponse {
    return new UpdateUserConversationResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UpdateUserConversationResponse {
    return new UpdateUserConversationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UpdateUserConversationResponse {
    return new UpdateUserConversationResponse().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | UpdateUserConversationResponse
      | PlainMessage<UpdateUserConversationResponse>
      | undefined,
    b:
      | UpdateUserConversationResponse
      | PlainMessage<UpdateUserConversationResponse>
      | undefined,
  ): boolean {
    return proto3.util.equals(UpdateUserConversationResponse, a, b);
  }
}

/**
 * @generated from message context_engine.UpdateUserConversationError
 */
export class UpdateUserConversationError extends Message<UpdateUserConversationError> {
  /**
   * @generated from oneof context_engine.UpdateUserConversationError.err
   */
  err:
    | {
        /**
         * @generated from field: google.protobuf.Empty not_found = 1;
         */
        value: Empty;
        case: "notFound";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<UpdateUserConversationError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UpdateUserConversationError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "not_found", kind: "message", T: Empty, oneof: "err" },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UpdateUserConversationError {
    return new UpdateUserConversationError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UpdateUserConversationError {
    return new UpdateUserConversationError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UpdateUserConversationError {
    return new UpdateUserConversationError().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | UpdateUserConversationError
      | PlainMessage<UpdateUserConversationError>
      | undefined,
    b:
      | UpdateUserConversationError
      | PlainMessage<UpdateUserConversationError>
      | undefined,
  ): boolean {
    return proto3.util.equals(UpdateUserConversationError, a, b);
  }
}

/**
 * @generated from message context_engine.UpdateDraftRequest
 */
export class UpdateDraftRequest extends Message<UpdateDraftRequest> {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId = "";

  /**
   * @generated from field: string draft_content = 2;
   */
  draftContent = "";

  constructor(data?: PartialMessage<UpdateDraftRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UpdateDraftRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "conversation_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 2,
      name: "draft_content",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UpdateDraftRequest {
    return new UpdateDraftRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UpdateDraftRequest {
    return new UpdateDraftRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UpdateDraftRequest {
    return new UpdateDraftRequest().fromJsonString(jsonString, options);
  }

  static equals(
    a: UpdateDraftRequest | PlainMessage<UpdateDraftRequest> | undefined,
    b: UpdateDraftRequest | PlainMessage<UpdateDraftRequest> | undefined,
  ): boolean {
    return proto3.util.equals(UpdateDraftRequest, a, b);
  }
}

/**
 * @generated from message context_engine.UpdateDraftResponse
 */
export class UpdateDraftResponse extends Message<UpdateDraftResponse> {
  /**
   * @generated from field: context_engine.UserConversation conversation = 1;
   */
  conversation?: UserConversation;

  constructor(data?: PartialMessage<UpdateDraftResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UpdateDraftResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversation", kind: "message", T: UserConversation },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UpdateDraftResponse {
    return new UpdateDraftResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UpdateDraftResponse {
    return new UpdateDraftResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UpdateDraftResponse {
    return new UpdateDraftResponse().fromJsonString(jsonString, options);
  }

  static equals(
    a: UpdateDraftResponse | PlainMessage<UpdateDraftResponse> | undefined,
    b: UpdateDraftResponse | PlainMessage<UpdateDraftResponse> | undefined,
  ): boolean {
    return proto3.util.equals(UpdateDraftResponse, a, b);
  }
}

/**
 * @generated from message context_engine.UpdateDraftError
 */
export class UpdateDraftError extends Message<UpdateDraftError> {
  /**
   * @generated from oneof context_engine.UpdateDraftError.err
   */
  err:
    | {
        /**
         * @generated from field: google.protobuf.Empty not_found = 1;
         */
        value: Empty;
        case: "notFound";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<UpdateDraftError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UpdateDraftError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "not_found", kind: "message", T: Empty, oneof: "err" },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UpdateDraftError {
    return new UpdateDraftError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UpdateDraftError {
    return new UpdateDraftError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UpdateDraftError {
    return new UpdateDraftError().fromJsonString(jsonString, options);
  }

  static equals(
    a: UpdateDraftError | PlainMessage<UpdateDraftError> | undefined,
    b: UpdateDraftError | PlainMessage<UpdateDraftError> | undefined,
  ): boolean {
    return proto3.util.equals(UpdateDraftError, a, b);
  }
}

/**
 * @generated from message context_engine.CheckFileRequest
 */
export class CheckFileRequest extends Message<CheckFileRequest> {
  /**
   * @generated from field: repeated context_engine.DocumentInfo document_infos = 1;
   */
  documentInfos: DocumentInfo[] = [];

  /**
   * @generated from field: bool perform_slow_doc_body_checks = 2;
   */
  performSlowDocBodyChecks = false;

  constructor(data?: PartialMessage<CheckFileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.CheckFileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "document_infos",
      kind: "message",
      T: DocumentInfo,
      repeated: true,
    },
    {
      no: 2,
      name: "perform_slow_doc_body_checks",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): CheckFileRequest {
    return new CheckFileRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): CheckFileRequest {
    return new CheckFileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): CheckFileRequest {
    return new CheckFileRequest().fromJsonString(jsonString, options);
  }

  static equals(
    a: CheckFileRequest | PlainMessage<CheckFileRequest> | undefined,
    b: CheckFileRequest | PlainMessage<CheckFileRequest> | undefined,
  ): boolean {
    return proto3.util.equals(CheckFileRequest, a, b);
  }
}

/**
 * @generated from message context_engine.CheckFileResult
 */
export class CheckFileResult extends Message<CheckFileResult> {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId = "";

  /**
   * @generated from field: bool is_chatable = 2;
   */
  isChatable = false;

  /**
   * @generated from field: string error_code = 3;
   */
  errorCode = "";

  constructor(data?: PartialMessage<CheckFileResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.CheckFileResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_chatable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "error_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): CheckFileResult {
    return new CheckFileResult().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): CheckFileResult {
    return new CheckFileResult().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): CheckFileResult {
    return new CheckFileResult().fromJsonString(jsonString, options);
  }

  static equals(
    a: CheckFileResult | PlainMessage<CheckFileResult> | undefined,
    b: CheckFileResult | PlainMessage<CheckFileResult> | undefined,
  ): boolean {
    return proto3.util.equals(CheckFileResult, a, b);
  }
}

/**
 * @generated from message context_engine.CheckFileResponse
 */
export class CheckFileResponse extends Message<CheckFileResponse> {
  /**
   * @generated from field: repeated context_engine.CheckFileResult file_checks = 1;
   */
  fileChecks: CheckFileResult[] = [];

  constructor(data?: PartialMessage<CheckFileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.CheckFileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "file_checks",
      kind: "message",
      T: CheckFileResult,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): CheckFileResponse {
    return new CheckFileResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): CheckFileResponse {
    return new CheckFileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): CheckFileResponse {
    return new CheckFileResponse().fromJsonString(jsonString, options);
  }

  static equals(
    a: CheckFileResponse | PlainMessage<CheckFileResponse> | undefined,
    b: CheckFileResponse | PlainMessage<CheckFileResponse> | undefined,
  ): boolean {
    return proto3.util.equals(CheckFileResponse, a, b);
  }
}

/**
 * @generated from message context_engine.CheckFileError
 */
export class CheckFileError extends Message<CheckFileError> {
  /**
   * @generated from oneof context_engine.CheckFileError.err
   */
  err:
    | {
        /**
         * @generated from field: context_engine.AnswersWorkflowError workflow_err = 2;
         */
        value: AnswersWorkflowError;
        case: "workflowErr";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<CheckFileError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.CheckFileError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 2,
      name: "workflow_err",
      kind: "message",
      T: AnswersWorkflowError,
      oneof: "err",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): CheckFileError {
    return new CheckFileError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): CheckFileError {
    return new CheckFileError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): CheckFileError {
    return new CheckFileError().fromJsonString(jsonString, options);
  }

  static equals(
    a: CheckFileError | PlainMessage<CheckFileError> | undefined,
    b: CheckFileError | PlainMessage<CheckFileError> | undefined,
  ): boolean {
    return proto3.util.equals(CheckFileError, a, b);
  }
}
